import { render, staticRenderFns } from "./DataNotFound.vue?vue&type=template&id=7eee2fdf&"
import script from "./DataNotFound.vue?vue&type=script&lang=js&"
export * from "./DataNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports